/* GENTCREATE — search behaviour.
 *
 * The panel's look is CSS. This file exists because the stock Search class in
 * theme.js is missing five things, each of which is a real defect a shopper
 * hits, not a nicety:
 *
 *   1. Escape does not close it. Every other overlay in the theme closes on
 *      Escape — Drawer, Modal, Popover and VariantSelector all carry the same
 *      `27===e.keyCode && this.close()` handler. Search alone has none.
 *
 *   2. Clicking the dimmed page does not close it. The Drawer class binds
 *      `pageOverlayElement.addEventListener("click", this._closeListener)`.
 *      Search shows the same overlay and never binds the listener — so the
 *      scrim swallows every click on the page and does nothing with any of
 *      them. The only way out is the small x.
 *
 *   3. ENTER DOES NOTHING. theme.js: `_preventSubmission` calls
 *      preventDefault on Enter whenever searchMode !== 'product'. This store
 *      is set to 'product,article', so the branch is always taken: a shopper
 *      who types a query and presses Enter — which is most of them — gets
 *      nothing at all, and the full results page is reachable only by
 *      noticing the small "View all" link. This is the expensive one.
 *
 *   4. Focus is never returned to the trigger on close, so a keyboard user is
 *      dropped at the top of the document.
 *
 *   5. The query and its results are never cleared, so reopening the panel
 *      shows the previous search.
 *
 * Everything here is additive and delegated; no theme.js behaviour is
 * replaced, and if this file fails to load the panel works exactly as it does
 * today.
 */
(function () {
  if (window.__gcSearchInit) return;
  window.__gcSearchInit = 1;

  var lastTrigger = null;

  function panel() { return document.getElementById('Search'); }
  function isOpen() { var p = panel(); return !!p && p.getAttribute('aria-hidden') === 'false'; }
  function input() { return document.querySelector('.Search__Input'); }
  function closer() { return document.querySelector('[data-action="close-search"]'); }

  /* Close through the theme's own button rather than by setting aria-hidden
     here. theme.js's _closeSearch also releases the focus trap, removes
     no-scroll from <html> and clears the header's inline z-index — reproducing
     that would mean owning it forever. */
  function close() { var b = closer(); if (b) b.click(); }

  /* remember what opened the panel, so focus has somewhere to go back to */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-action="toggle-search"]');
    if (t) lastTrigger = t;
  }, true);

  /* 1 — Escape */
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && isOpen()) {
      e.preventDefault();
      close();
    }
  });

  /* 3 — Enter reaches the results page.
     Capture phase at the document, so this runs before _preventSubmission can
     cancel the event. stopImmediatePropagation is belt-and-braces: navigation
     is already scheduled by the time anything else could run.

     window.routes.searchUrl rather than a literal '/search' — it is
     locale-prefixed, and this store serves eighteen of them. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.keyCode !== 13) return;
    var i = e.target;
    if (!i || !i.classList || !i.classList.contains('Search__Input')) return;
    var q = (i.value || '').trim();
    if (!q) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var base = (window.routes && window.routes.searchUrl) || '/search';
    var types = (window.theme && window.theme.searchMode) || 'product';
    window.location.href = base + '?q=' + encodeURIComponent(q) + '&type=' + encodeURIComponent(types);
  }, true);

  /* 2 — clicking the dimmed page closes the panel.
     Bound on the document rather than on .PageOverlay itself, because
     gc-cart-drawer.js reaches in and rewrites that element's inline styles and
     classes; a listener attached directly to it is one refactor away from
     being dropped. Guarded on isOpen() so this never competes with the
     drawers, which own the same element. */
  document.addEventListener('click', function (e) {
    if (!isOpen()) return;
    var t = e.target;
    if (t && t.classList && t.classList.contains('PageOverlay')) close();
  });

  /* 4 and 5 — clear the query and hand focus back.
     Deferred past the .3s close transition so the results do not visibly empty
     while the panel is still fading out. Dispatching 'input' is deliberate: it
     is what theme.js listens on, and an empty value routes into its own
     _resetSearch, so the results markup is torn down by the code that built
     it. */
  document.addEventListener('click', function (e) {
    if (!(e.target.closest && e.target.closest('[data-action="close-search"]'))) return;
    window.setTimeout(function () {
      var i = input();
      if (i && i.value) {
        i.value = '';
        i.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    }, 330);
  });

  /* A state hook for the panel's own loading treatment. theme.js already
     dispatches these two events around the fetch pair; it just has nothing but
     the 2px .LoadingBar at the top of the window to show for them, which is
     invisible while you are looking at a panel below the header. */
  document.addEventListener('theme:loading:start', function () {
    var p = document.querySelector('.Search__Inner');
    if (p && isOpen()) p.classList.add('is-searching');
  });
  document.addEventListener('theme:loading:end', function () {
    var p = document.querySelector('.Search__Inner');
    if (p) p.classList.remove('is-searching');
  });
})();
